export default __webpack_public_path__ + "static/media/blog-level-2.10d14da3.svg";